import { useEffect, useState } from 'react';

import getPostsByCategory from '../api/graphql/queries/getPostsByCategory';

const useArtistList = () => {
  const [artists, setArtists] = useState();

  useEffect(() => {
    getPostsByCategory('artist').then((data) => {
      if (!data?.isAuth) { console.warn('artist data = null'); return; }
      const posts = data.posts.map(post => ({ label: post.postDescription?.title?.en, value: post.slugName }));
      setArtists(posts);
    });
  }, []);

  return artists;
};

export default useArtistList;
